var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container data_governance_page"},[_c('PageTop'),_c('div',{staticStyle:{"display":"flex","position":"relative","width":"100%","height":"100%","background":"#fff"}},[_c('SideNavigation'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }